<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    :width="dialogWidth"
    :close-on-click-modal="false"
    @close="closeHandler"
  >
    <el-form v-if="elementformulaEditable" inline>
      <el-form-item label="Account">
        <el-select ref="accountTitleRef" v-model="form.accountTitle" style="width: 300px;" :filterable="true" :clearable="true" placeholder="Please select">
          <el-option
            v-for="(item,index) in newAccountCollection"
            :key="index"
            :label="accountTitleLabelFun(item)"
            :value="item.accountTitle"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addAccountTitleBtnClickHandler">Add</el-button>
      </el-form-item>
    </el-form>
    <div>
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%;height:300px;padding-left:2px"
      />
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="footer.gridOptions"
        :column-defs="columnDefs2"
        :row-data="footer.rowData"
        :auto-fit-content="false"
        class="accounting-document-grid accounting-document-grid-footer"
        style="width:100%;padding-left:2px"
      />
    </div>
    <div slot="footer" style="padding-right:300px">
      <el-button v-if="elementformulaEditable" type="primary" @click="saveHander">Confirm</el-button>
      <el-button @click="closeHandler">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import * as statementElementDescriptionApi from '@/api/financeManage/statementElementDescription'
import * as NumberUtils from '@/utils/NumberUtils'
import { DocumentManage } from '@/utils/commonUtil'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'

export default {
  name: 'StatementElementDialog',
  props: {
    visible: { type: Boolean, required: true },
    atbDictionary: { type: Object, required: true },
    accountSet: { type: Object, default: null },
    elementformulaEditable: { type: Boolean, required: true },
    statementDescriptionUuid: { type: String, required: true },
    statementDescription: { type: Object, default: null }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      innerVisible: false,
      form: {
        accountTitle: ''
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          sortable: false // 去掉每列的排序
        },
        suppressContextMenu: true,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      rowData: [],
      footer: {
        gridOptions: {
          alignedGrids: [],
          headerHeight: 0,
          suppressContextMenu: true,
          suppressRowSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 30,
          defaultColDef: {
            suppressMenu: true,
            suppressMovable: true,
            headerClass: 'text-center'
          }
        },
        rowData: [
          {
            accountTitle: 'Total',
            ending: '',
            beginningYear: ''
          }
        ]
      }
    }
  },
  computed: {
    // 科目
    accountTitleCollection() {
      return this.accountSet ? this.accountSet.accountTitle : []
    },
    newAccountCollection() {
      if (!this.accountTitleCollection) return []
      if (!this.statementDescription.statementElementDescription) return this.accountTitleCollection
      const list = []
      for (const title of this.accountTitleCollection) {
        const statement = this.statementDescription.statementElementDescription.find(element => title.accountTitle === element.elementNo)
        if (!statement) list.push(title)
      }
      return list
    },
    title() {
      return 'New line items'
    },
    columnDefs() {
      return [
        { headerName: 'Account No.', field: 'elementNo', width: 120 },
        {
          headerName: 'Account name', field: 'name', width: 200, editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor'
        },
        {
          headerName: 'Line No.', field: 'lineNo', width: 90, editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              min: 1,
              max: 100,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          }
        },
        {
          headerName: this.endingHeadName(), field: 'ending', width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.beginningYearHeadName(), field: 'beginningYear', width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('delete')
            const del = this.$t('CargoMsg.Cargo_Delete')
            return `<a onclick="${methodPath}('${params.rowIndex}')" style="color: red;text-decoration: underline;">${del}</a>`
          },
          cellStyle: { textAlign: 'center' }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_AccountTitle'),
          field: 'accountTitle',
          width: 410
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PeriodEndAmount'),
          field: 'ending',
          width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear'),
          field: 'beginningYear',
          width: 120,
          valueFormatter: params => {
            return NumberUtils.formatRoundNumber(params.value, 2)
          },
          cellStyle: { textAlign: 'right' }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          hide: !this.elementformulaEditable,
          width: 80
        }
      ]
    },
    dialogWidth() {
      return this.elementformulaEditable ? '775px' : '695px'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        // 加载列表数据
        this.loadData()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.$emit('close')
      }
    }
  },
  beforeMount() {
    const self = this
    this.documentManage.set('delete', function(data) {
      self.deleteClickHandler(data)
    })
  },
  methods: {
    async loadData() {
      if (!this.statementDescriptionUuid) return
      await this.fillItem()
      this.total()
    },
    accountTitleLabelFun(accountTitle) {
      return accountTitle ? accountTitle.accountTitle + ' ' + accountTitle.accountTitleName : ''
    },
    async addAccountTitleBtnClickHandler() {
      if (!this.form.accountTitle) return
      if (this.rowData.find(statementElement => statementElement.elementNo === this.form.accountTitle) !== undefined) {
        this.$message.warning(this.form.accountTitle + ' already existed')
        return
      }
      this.rowData.push(await this.creatItem(this.form.accountTitle))
      this.clearForm()
      this.total()
    },
    async creatItem(accountTitle) {
      const ac = this.getAccountTitle(accountTitle)
      const result = {}
      result.elementNo = accountTitle
      result.name = ac.accountTitleName
      result.lineNo = this.rowData.length + 1
      const atb = this.getAccountTitleBalance(accountTitle)
      if (atb) {
        if (this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
          result.beginningYear = atb.currentMonthTotalAmount
          result.ending = atb.currentYearTotalAmount
        } else {
          result.beginningYear = atb.beginningBalance
          result.ending = atb.currentMonthBalanceAmount
        }
      } else {
        result.beginningYear = 0
        result.ending = 0
      }
      return result
    },
    clearForm() {
      this.form.accountTitle = ''
    },
    getAccountTitle(accountTitle) {
      if (!this.accountTitleCollection || !accountTitle) {
        return null
      }
      return this.accountTitleCollection.find(title => title.accountTitle === accountTitle)
    },
    getAccountTitleBalance(accountTitle) {
      return this.atbDictionary[accountTitle]
    },
    saveHander() {
      for (const item of this.rowData) {
        if (!item.elementFormula) item.elementFormula = []
        if (!item.statementElement) item.statementElement = []
      }
      this.statementDescription.statementElementDescription = this.rowData
      if (!this.statementDescription.statementColumnDescription) this.statementDescription.statementColumnDescription = []
      const loading = getLoading()
      statementElementDescriptionApi.saveList(this.statementDescription).then(resp => {
        this.statementDescription.statementElementDescription = []
        this.statementDescription.statementElementDescription = resp.data
        this.closeHandler()
      }).finally(() => loading.close())
    },
    deleteClickHandler(rowIndex) {
      this.rowData.splice(rowIndex, 1)
      let rowCount = 1
      this.rowData.forEach(row => { row.lineNo = rowCount; rowCount++ }) // 重置Line No
    },
    closeHandler() {
      this.clearForm()
      this.$emit('close')
    },
    async fillItem() {
      Object.assign(this.rowData, this.statementDescription.statementElementDescription)
      for (const statementElement of this.rowData) {
        const atb = this.getAccountTitleBalance(statementElement.elementNo)
        if (atb) {
          statementElement.beginningYear = atb.beginningBalance
          statementElement.ending = atb.currentMonthBalanceAmount
        } else {
          statementElement.beginningYear = 0
          statementElement.ending = 0
        }
      }
    },
    // 合计
    total() {
      let ending = 0
      let beginningYear = 0
      for (const row of this.rowData) {
        ending += Number(row.ending)
        beginningYear += Number(row.beginningYear)
      }
      this.footer.rowData[0].ending = ending
      this.footer.rowData[0].beginningYear = beginningYear
      this.footer.gridOptions.api.refreshCells({ force: true })
    },
    endingHeadName() {
      if (this.statementDescriptionUuid && this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_CurrentYearAccumulatedAmount')
      } else {
        return this.$t('CargoMsg.Cargo_PeriodEndAmount')
      }
    },
    beginningYearHeadName() {
      if (this.statementDescriptionUuid && this.statementDescription.statementName.indexOf('ProfitLoss') !== -1) {
        return this.$t('CargoMsg.Cargo_AmountOfCurrentMonth')
      } else {
        return this.$t('CargoMsg.Cargo_OpeningAmountOfTheYear')
      }
    }
  }
}
</script>

<style lang="scss">
.accounting-document-grid{
  .ag-cell-inline-editing {
    height: 100%!important;
  }
  .ag-header-cell{
    &.text-center {
      text-align: center;
      .ag-header-cell-text{
        display: inline;
        width: 100%;
        height: 100%;
        line-height: 64px;
      }
    }
    &::after {
      height: 48px;
    }
  }
  .ag-cell {
    border-right: 1px solid #d9dcde;
  }
  .ag-cell-inline-editing {
    height: 30px;
  }
  &-footer {
    height: 34px;
    .ag-theme-balham {
      min-height: 34px!important;
    }
  }
}

</style>
